import { ExternalLink } from "lucide-react"
import { PLU_COLORS } from "@/components/explore/panels/plu-colors"
import { DataRow } from "./data-row"

export interface PLUInfo {
  libelle: string
  libelong?: string
  typezone?: string
  gpu_timestamp?: string
  gpu_doc_id?: string
  nomfic?: string
}

interface PLUDetailsProps {
  selectedPLU: PLUInfo
}

const formatDate = (dateStr?: string) => {
  if (!dateStr) return ""
  const d = new Date(dateStr)
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" })
}

export const PLUDetails = ({ selectedPLU }: PLUDetailsProps) => {
  const pluColor = (selectedPLU?.typezone ? PLU_COLORS[selectedPLU.typezone] : undefined) || PLU_COLORS.default

  return (
    <div className="pt-1">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: pluColor }} />
        <span className="text-sm font-medium text-gray-800">{selectedPLU.libelle}</span>
      </div>
      {selectedPLU.libelong && <div className="text-sm text-gray-500 mb-1">{selectedPLU.libelong}</div>}
      {selectedPLU.typezone && <DataRow label="Type" value={selectedPLU.typezone} />}
      <DataRow label="Révision" value={formatDate(selectedPLU?.gpu_timestamp)} />
      {selectedPLU.gpu_doc_id && selectedPLU.nomfic && (
        <a
          href={`https://www.geoportail-urbanisme.gouv.fr/api/document/${selectedPLU.gpu_doc_id}/files/${selectedPLU.nomfic}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary/80 mt-2"
        >
          Consulter le PLU
          <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </div>
  )
}
